import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ClusterDetailAPI } from "../../../../api/specialization/ClusterDetailAPI";
import { errorNoti } from "../../../../util/SnackbarMessage";
import { useSnackbar } from "notistack";
import TrendzContainerCard from "../../../../components/TrendzContainerCard";
import { KeywordClusterReport } from "./KeywordClusterReport";
import { Tab, Tabs, Tooltip } from "@mui/material";
import KeywordClusterFeed from "./KeywordClusterFeed";
export default function KeywordClusterDetail() {
  const { t } = useTranslation(["common", "keyword", "social"]);
  const { id } = useParams();
  const [currentTab, setCurrentTab] = useState("feed");
  const [cluster, setCluster] = useState({ name: "", relatedKeywords: [] });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (id) {
      ClusterDetailAPI(parseInt(id))
        .then((res) => {
          setCluster(res["cluster"]);
        })
        .catch((err) => {
          var noti = errorNoti(err);
          enqueueSnackbar(t("error:" + noti.message), noti.option);
        });
    }
  }, []);

  var title =
    t("keyword:dashboard_for_cluster") + " '" + cluster!["name"] + "'";
  var detail = <div></div>;

  if (currentTab == "feed") {
    title =
      t("keyword:latest_content") +
      " " +
      t("common:about") +
      " '" +
      cluster!["name"] +
      "'";
    detail = <KeywordClusterFeed />;
  }

  if (currentTab == "overview") {
    title =
      t("common:overview") +
      " " +
      t("common:about") +
      " '" +
      cluster!["name"] +
      "'";
  }

  if (currentTab == "report") {
    detail = <KeywordClusterReport />;
  }
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  return (
    <TrendzContainerCard title={title}>
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        style={{ marginBottom: "2px" }}
      >
        <Tab
          label={
            <Tooltip title={t("common:overview")}>
              <div>{t("common:overview")}</div>
            </Tooltip>
          }
          value="overview"
        ></Tab>
        <Tab
          label={
            <Tooltip title={t("keyword:latest_content")}>
              <div>{t("keyword:latest_content")}</div>
            </Tooltip>
          }
          value="feed"
        ></Tab>

        <Tab
          label={
            <Tooltip title={t("keyword:detailed_reports")}>
              <div>{t("keyword:detailed_reports")}</div>
            </Tooltip>
          }
          value="report"
        ></Tab>
      </Tabs>
      {detail}
    </TrendzContainerCard>
  );
}
